export const getBuilderLocaleProps = (locale: string) => ({
  locale,
  data: { locale },
  context: { locale },
  options: {
    locale,
    data: { locale },
  },
});
